export function applySmoothwallTheme(): void {
	document.documentElement.style.setProperty("--login-bg-color", "#00A49C");
	document.documentElement.style.setProperty("--primary-color", "#00A49C");
	document.documentElement.style.setProperty("--primary-color-button-disabled", "rgba(0, 187, 180, 0.6)");
	document.documentElement.style.setProperty("--primary-color", "#00A49C");
	document.documentElement.style.setProperty("--primary-color-button-hover", "#009089");
	document.documentElement.style.setProperty("--send-feedback-button-hover-bg", "#027872");
	document.documentElement.style.setProperty("--monitoring-color", "#00A49C");
	document.documentElement.style.setProperty("--monitoring-color-button-hover", "#027872");

	document.title = "Smoothwall";
	let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
	if (!link) {
		link = document.createElement("link");
		link.rel = "icon";
		document.getElementsByTagName("head")[0].appendChild(link);
	}
	link.href = "/static/smoothwallfavicon-16x16.png";
}
